import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="about-container">
        {/* Hero Section */}
        <div className="about-hero">
          <div className="about-hero-background">
            <div className="hero-gradient-orb"></div>
            <div className="hero-floating-particles">
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
            </div>
          </div>
          
          <div className="about-hero-content">
            
            <h1 className="about-title">About DevRoom</h1>
            <p className="about-subtitle">
              Empowering developers to collaborate, innovate, and build extraordinary projects
            </p>
          </div>
        </div>



        {/* Mission Section */}
        <div className="about-section">
          <div className="section-header">
           
            <h2 className="section-title">Our Mission</h2>
          </div>
          <div className="mission-content">
            <div className="mission-card">
              <p className="mission-text">
                DevRoom was born from a simple belief: <span className="text-highlight">great software is built by great teams working together</span>. 
                We provide developers with powerful, collaborative development environments that remove barriers 
                and amplify creativity.
              </p>
              <p className="mission-text">
                Our platform enables seamless collaboration, instant project setup, and scalable development 
                workflows that grow with your team. Whether you're a solo developer or part of a large organization, 
                DevRoom adapts to your needs.
              </p>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="about-section">
          <div className="section-header">
            
            <h2 className="section-title">Our Values</h2>
          </div>
          <div className="values-grid">
            <div className="value-card hover-lift">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="value-title">Collaboration First</h3>
              <p className="value-description">
                We believe the best solutions emerge when talented people work together seamlessly.
              </p>
            </div>
            
            <div className="value-card hover-lift">
              <div className="value-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3 className="value-title">Innovation</h3>
              <p className="value-description">
                We constantly push boundaries to provide cutting-edge tools and experiences.
              </p>
            </div>
            
            <div className="value-card hover-lift">
              <div className="value-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3 className="value-title">Security</h3>
              <p className="value-description">
                Your code and data are protected with enterprise-grade security measures.
              </p>
            </div>
            
            <div className="value-card hover-lift">
              <div className="value-icon">
                <i className="fas fa-expand-arrows-alt"></i>
              </div>
              <h3 className="value-title">Scalability</h3>
              <p className="value-description">
                Our platform grows with you, from prototype to production.
              </p>
            </div>
          </div>
        </div>
        


        {/* CTA Section */}
        <div className="about-cta">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Build Something Amazing?</h2>
            <p className="cta-description">
              Join thousands of developers who trust DevRoom for their projects
            </p>
            <div className="cta-actions">
              <button 
                onClick={() => navigate('/dashboard')}
                className="cta-btn primary"
                style={{ background: '#0f3460', boxShadow: '0 4px 15px rgba(0, 102, 255, 0.3)' }}
              >
                <i className="fas fa-rocket"></i>
                <span>Get Started</span>
              </button>
              <button 
                onClick={() => navigate('/team')}
                className="cta-btn secondary"
              >
                <i className="fas fa-users"></i>
                <span>Meet Our Team</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
